const state = {
  preSearch: false
}

const mutations = {
  SET_PRE_SEARCH: (state, data) => {
    state.preSearch = data
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
